import { render, staticRenderFns } from "./SelectorAuditor.vue?vue&type=template&id=dffaf4e2"
import script from "./SelectorAuditor.vue?vue&type=script&lang=js"
export * from "./SelectorAuditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports